import { TrainingResponse } from "../../../../models/Training";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import ApiClient from "../../../apiClient";

export async function training(TRAINING_ID: number): Promise<TrainingResponse> {
  const res = await ApiClient.get(
    `/Training?TRAINING_ID=${TRAINING_ID}`
  );
  return res.data[0];
}

export const useFetchTraining = mutationWrapper(training);
